/**
 * ThemeProvider — wraps app with next-themes provider (D-21)
 *
 * O site segue SOMENTE a preferencia do sistema operacional. O seletor de tema
 * (3 botoes no rodape) foi removido em 10/09/2026 a pedido do operador.
 *
 * O next-themes CONTINUA aqui porque `src/components/ui/sonner.tsx` chama
 * useTheme() para pintar os toasts no tema certo. Sem o provider, o Sonner cairia
 * no default e poderia renderizar toast claro em tema escuro.
 *
 * - attribute="class": aplica a classe dark/light no <html>
 * - defaultTheme="system" + enableSystem: acompanha o SO, inclusive se o usuario
 *   trocar com a aba aberta
 * - SEM storageKey: nada persiste escolha de tema, porque nao ha mais escolha.
 *   A chave legada 'theme' de quem usou o seletor antigo e apagada pelo script
 *   inline do index.html — senao essa pessoa ficaria travada no tema antigo sem
 *   nenhum controle para sair.
 * - disableTransitionOnChange: evita FOUC na troca
 */
import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      // Só tema claro desde 2026-10-20: o site inteiro virou papel creme. Com o
      // modo escuro do sistema, os cartões (bg-card) ficavam pretos sobre o
      // papel claro. O next-themes fica por causa do Sonner.
      forcedTheme="light"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
